import styled from 'styled-components';

export const Container = styled.div``;
export const Button = styled.span`
  width: 40px;
  height: 40px;
  border: 2px solid black;
`;
